/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ApplicationsIconConfig = {
  name: 'ApplicationsIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M950.827 643.87h-131.627v197.973c0 40.107-32.853 72.96-73.173 72.96h-672.853c-40.32 0-73.173-32.853-73.173-72.96v-534.613c0-40.32 32.853-73.173 73.173-73.173h131.627v-197.76c0-40.32 32.853-73.173 73.173-73.173h672.853c40.32 0 73.173 32.853 73.173 73.173v534.613c0 40.107-32.853 72.96-73.173 72.96zM887.467 577.524v-70.4h-68.267v70.4h68.267zM612.267 850.59h70.4v-70.4h-70.4v70.4zM70.187 308.51v402.133h679.040v-402.133h-679.040zM953.813 37.364h-678.827v196.693h471.040c40.32 0 73.173 32.853 73.173 73.173v132.48h134.613v-402.347z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(ApplicationsIconConfig);
//# sourceMappingURL=applications-icon.js.map